import { render, staticRenderFns } from "./promotion-checkout.vue?vue&type=template&id=70d8cc8a&scoped=true"
import script from "./promotion-checkout.vue?vue&type=script&lang=js"
export * from "./promotion-checkout.vue?vue&type=script&lang=js"
import style0 from "./promotion-checkout.vue?vue&type=style&index=0&id=70d8cc8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d8cc8a",
  null
  
)

export default component.exports